<template>
    <div>
<!--        <wp_card style="margin-top: 10px; box-shadow: 1px 1px 5px #909090">-->
<!--            <div slot="head"></div>-->
<!--            <van-row style="padding-left: 5px">-->
<!--                <van-col span="10">-->
<!--                    <h2>本月预估收入:</h2>-->
<!--                </van-col>-->
<!--                <van-col span="14">-->
<!--                    <h2><span style="color: red">￥{{monthCountData.efeetoday.toFixed(2)}}</span></h2>-->
<!--                </van-col>-->
<!--            </van-row>-->
<!--        </wp_card>-->

        <!--            计数器-->
        <Wp_access_count page-tag="income"></Wp_access_count>

        <div>
            <Wp_mini_data_card title="今日预估" :datas="today_income_list" :showRight="false" :showEye="false">

            </Wp_mini_data_card>
        </div>

        <div style="padding-top: 20px">
            <Wp_mini_data_card title="本月预估" :datas="month_income_list" :showRight="false" :showEye="false">

            </Wp_mini_data_card>
        </div>

        <div style="box-shadow: 1px 1px 5px #999999; margin-top: 20px; font-weight: bold;">
            <van-cell title="我的总预估收入详情" size="large" is-link @click="showIncomeDetail"/>
        </div>

<!--        <div v-if="$common.getLimitPayTime().canPay && $config.project !== 'hm'" style="padding: 10px; margin-top: 10px">-->
<!--            <van-button type="danger" size="large" @click="payDataDetail">提 款</van-button>-->
<!--        </div>-->

    </div>
</template>

<script>
    import Wp_mini_data_card from "../../custom/Wp_mini_data_card";
    import Wp_access_count from "../../custom/Wp_access_count";
    export default {
        name: "Wp_tb_order_count_new",
        components: {Wp_access_count, Wp_mini_data_card},
        // props: {
        //     pid: {
        //         type: String,
        //         default: null
        //     }
        // },
        data() {
            return {
                pid: "",
                active: '1',
                title:'今日数据',
                startTime:this.$store.state.startTime,
                endTime:this.$store.state.endTime,
                countData: {
                    code: 200,
                    efeed18: 0, //当天已结算金额
                    efeem18: 0,  //本月已结算金额
                    efeemonth: 0,  //本月预估收入
                    efeetoday: 0, //当天预估收入
                    epricemonth: 0,  //本月商品总额
                    epricetoday: 0,  //当天商品总额
                    msg: "sucess",
                },

                monthCountData: {
                    code: 200,
                    efeed18: 0, //当天已结算金额
                    efeem18: 0,  //本月已结算金额
                    efeemonth: 0,  //本月预估收入
                    efeetoday: 0, //当天预估收入
                    epricemonth: 0,  //本月商品总额
                    epricetoday: 0,  //当天商品总额
                    msg: "sucess",
                },

                orderCount : 0,

                efeetodayall: 0,

                today_income_list: [
                    // {
                    //     count: 0.00,
                    //     count_unit: "￥",
                    //     text: "今日推广收益"
                    // }
                ],
                month_income_list: [
                    // {
                    //     count: 0.00,
                    //     count_unit: "￥",
                    //     text: "本月推广收益"
                    // }
                ],


            }
        },
        created() {
            this.$log("this.startTime = " + this.startTime)
            this.pid = this.$common.getPid();
            this.getOrderCountBy();
        },
        mounted(){
            // this.getMonthCount();
        },
        methods: {

            showIncomeDetail(){
                this.$router.push("count_detail_page_tb")
            },

            getOrderCountBy() {
                let today_date = this.$common.dateFmt("yyyy-MM-dd", this.$common.dateAdd('d', 0, new Date()));
                let _data = {
                    pid: this.$common_tb.getTaobaoPid(),
                    stime: this.startTime,
                    etime: this.endTime,
                };
                this.$log(_data);
                // this.$getOrderCountByData(_data, function (response) {
                //     that.countData = response;
                //     that.$log(response);
                // })
                this.$getIncometByData_tb(_data, response=> {

                    this.$log(response);
                    if(response && response.code === 200){
                        this.countData = response;
                        this.efeetodayall = Number(response.efeetodayall).toFixed(2);
                        if(this.startTime === today_date && this.endTime === today_date){
                            this.$log("初始化今日数据")

                            this.initTadayIncomeDatas(response);
                        }
                    }
                })

            },

            initTadayIncomeDatas(response){
                if(response.type === "0"){

                    this.today_income_list = [
                        {
                            count: response.efeetodayall_user.toFixed(2),
                            count_unit: "￥",
                            text: "今日推广收益"
                        },
                        {
                            count: response.efeetodayall_he.toFixed(2),
                            count_unit: "￥",
                            text: "今日推荐收益"
                        },
                        {
                            count: response.efeetodayall.toFixed(2),
                            count_unit: "￥",
                            text: "今日全部收益"
                        }
                    ];
                    this.month_income_list = [
                        {
                            count: response.m_efeetodayall_user.toFixed(2),
                            count_unit: "￥",
                            text: "本月推广收益"
                        },
                        {
                            count: response.m_efeetodayall_he.toFixed(2),
                            count_unit: "￥",
                            text: "本月推荐收益"
                        },
                        {
                            count: response.m_efeetodayall.toFixed(2),
                            count_unit: "￥",
                            text: "本月全部收益"
                        }
                    ];
                }else if(response.type === "1" || response.type === "2"){

                    this.today_income_list = [
                        {
                            count: response.efeetodayall_user.toFixed(2),
                            count_unit: "￥",
                            text: "今日推广收益"
                        },
                        {
                            count: response.efeetodayall_he.toFixed(2),
                            count_unit: "￥",
                            text: "今日推荐收益"
                        },
                        {
                            count: response.efeetodayall_other.toFixed(2),
                            count_unit: "￥",
                            text: "今日专属收益"
                        },
                        {
                            count: response.efeetodayall.toFixed(2),
                            count_unit: "￥",
                            text: "今日全部收益"
                        }
                    ];
                    this.month_income_list = [
                        {
                            count: response.m_efeetodayall_user.toFixed(2),
                            count_unit: "￥",
                            text: "本月推广收益"
                        },
                        {
                            count: response.m_efeetodayall_he.toFixed(2),
                            count_unit: "￥",
                            text: "本月推荐收益"
                        },
                        {
                            count: response.m_efeetodayall_other.toFixed(2),
                            count_unit: "￥",
                            text: "本月专属收益"
                        },
                        {
                            count: response.m_efeetodayall.toFixed(2),
                            count_unit: "￥",
                            text: "本月全部收益"
                        }
                    ];
                }else{
                    this.today_income_list = [
                        {
                            count: 0,
                            count_unit: "￥",
                            text: "今日收益"
                        }
                    ];
                }
            },


            /**
             * 提款
             */
            payDataDetail(){
                this.$common_tb.pay_from_tb_data_page = true;
                this.$router.push('my');
            },
        }
    }
</script>

<style scoped>

</style>
